import React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { LTCPContextProvider } from "LTCP Module/LTCPContext";
import LTCPLayout from "LTCP Module/components/LTCPLayout";
import LoadingWidget from "LTCP Module/components/LoadingWidget";
import LandingPage from "LTCP Module/pages/LandingPage";
import AlertsPage from "LTCP Module/pages/AlertsPage";
import DashboardPage from "LTCP Module/pages/DashboardPage";
import CUPage from "LTCP Module/pages/CUPage";
import UploadPage from "LTCP Module/pages/UploadPage";
import CapacityPage from "LTCP Module/pages/CapacityPage";
import DemandPage from "LTCP Module/pages/DemandPage";
import ReportPage from "LTCP Module/pages/ReportPage";
import Recommendation from "LTCP Module/pages/Recommendation";

import "./index.css";
import RoleManagement from "LTCP Module/pages/RoleManagement";
import AlertWidget from "LTCP Module/components/AlertWidget";
import CapacitySimulation from "LTCP Module/pages/CapacitySimulation";

const LTCPRouter = () => {
  const theme = createTheme({
    palette: {
      primary: {
        light: "#F6F7FF",
        main: "#1F36C7",
        dark: "#1F36C7",
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: "0px 2px 5px 0px rgba(214, 222, 248, 1)",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            fontSize: 12,
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            border: "1px solid white",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "8px",
            paddingRight: "8px",
            fontSize: 13,
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            padding: 0,
            width: 70,
            height: 24,
            maxHeight: 24,
            fontSize: 12,
            textTransform: "none",

            "&.Mui-selected": {
              backgroundColor: "#1F36C7",
              color: "#FFFFFF",
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <LTCPContextProvider>
        <LoadingWidget>
          <AlertWidget>
            <Routes>
              <Route path="landing" element={<LandingPage />} />
              <Route path="dashboard" element={<LTCPLayout />}>
                <Route path="alerts" element={<AlertsPage />} />
                <Route path="overview" element={<DashboardPage />} />
                <Route path="cu" element={<CUPage />} />
                <Route path="uploads" element={<UploadPage />} />
                <Route path="capacity" element={<CapacityPage />} />
                <Route path="demand" element={<DemandPage />} />
                <Route path="reports" element={<ReportPage />} />
                <Route path="roles" element={<RoleManagement />} />
                <Route path="simulation" element={<CapacitySimulation />} />
                <Route
                  path="recommendation/:factory/:format"
                  element={<Recommendation />}
                />
              </Route>
            </Routes>
          </AlertWidget>
        </LoadingWidget>
      </LTCPContextProvider>
    </ThemeProvider>
  );
};

export default LTCPRouter;
